import curryN from './curryN';
const ifElse=(condition, onTrue, onFalse)=> {
    return curryN(
        function _ifElse() {
            return condition.apply(null, arguments) ? onTrue.apply(null, arguments) : onFalse.apply(null, arguments);
        },Math.max(condition.length, onTrue.length, onFalse.length)
    );
  };
  export default ifElse;



// WEBPACK FOOTER //
// ./src/ifElse.ts